import React, { useEffect } from 'react'
import { Meteor } from 'meteor/meteor'
import queue from 'async/queue'

import { MuiThemeProvider } from '@material-ui/core/styles'

import MainLoader from './components/loadings/MainLoader'
import useTracker from './lib/useTracker'

import { useGlobalState } from './store'
import customMaterialTheme from './globalStyle'
import { fetchCategories } from './lib/categories'
import { fetchThemes } from './lib/theme'
import { fetchCustomerType } from './lib/customerTypes'
import { fetchLawyers, fetchMe } from './lib/user'
import { fetchOffers } from './lib/offers'
import { fetchBarreaux } from './lib/barreaux'
import { fetchLanguages } from './lib/languages'
import { fetchCompetences } from './lib/competences'
import { fetchExperience } from './lib/experience'
import { fetchFeesMode } from './lib/feesMode'
import { fetchSettings } from './lib/settings'
import { fetchSuggestions } from './lib/suggestions'
import { fetchCallPartner } from './lib/callPartner'

type Props = {
  children: React.FC,
}

export let queueControl = queue(function (fields, callback) {
  fetchLawyers(fields._id).finally(() => callback())
}, 5)

const LoaderData = ({ children }: Props) => {
  const [theme] = useGlobalState('theme')

  const user = useTracker(() => Meteor.user(), [])
  const pro = user?.profile.pro
  const email = user?.profile.type

  useEffect(() => {
    Meteor.subscribe('userData')
    fetchThemes()
    fetchMe()
    fetchSettings()
    fetchCategories()
    fetchLanguages()
    fetchBarreaux()
    fetchExperience()
    // User connected and loaded
    if (user) {
      fetchCompetences()
      fetchOffers()
      fetchFeesMode()
      fetchCustomerType()
      fetchSuggestions()
      fetchCallPartner()
    }
  }, [pro, email])

  // We must wait dependencies like theme and user profile (if the user is connected)
  if (!theme.loaded) return <MainLoader open />

  return <MuiThemeProvider theme={customMaterialTheme(theme)}>{children}</MuiThemeProvider>
}

export default React.memo(LoaderData)
